export enum OrthOExaminationOrder {
    notFocusable = -1,
    previousExamination,
    anamnese,
    anamneseOd,
    anamneseOs,
    anamneseFamilyHistory,
    ocularAlignmentExamination,
    binocularExamination,
    ocularMotilityExamination,
    checkedVisionExaminationOd,
    checkedVisionExaminationOs,
    checkedVisionExaminationOds,
    extraVisusExaminationsOd,
    extraVisusExaminationsOs,
    extraVisusExaminationsDynamicSkiacopy,
    extraVisusExaminationsVisionNearOd,
    extraVisusExaminationsVisionNearOs,
    extraVisusExaminationsVisionNearOds,
    extraAdditionalExaminations,
    extraAdditionalExaminationOd,
    extraAdditionalExaminationOs,
    extraAdditionalExaminationOds,
    extraAdditionalLast,
}
